import { Component, Input, OnInit } from "@angular/core";
import { Router, UrlTree } from "@angular/router";
import { NavGroup } from "./../shared/models/nav-group";
import { NavItem } from "./../shared/models/nav-item";

@Component({
  selector: "app-nav-group",
  templateUrl: "./nav-group.component.html",
})
export class NavGroupComponent implements OnInit {
  @Input() navGroup: NavGroup;
  navItems: NavItem[];

  constructor(private router: Router) {}

  ngOnInit() {
    this.navItems = this.navGroup.items.filter((g) => g.isVisible);
  }

  hasItems(): boolean {
    return this.navItems.length > 0;
  }

  isRouteActive(route: string | null | undefined): boolean {
    if (!route) {return false;}
    try {
      const urlTree: UrlTree = this.router.createUrlTree([route]);
      return this.router.isActive(urlTree, {
        paths: "exact",
        queryParams: "ignored",
        fragment: "ignored",
        matrixParams: "ignored",
      });
    } catch {
      return false;
    }
  }
}
